import { Select, Skeleton } from '@efast_public/fjd-component-library';
import {
  AntragObj,
  BearbeiterDto
} from '../../../api/models/Antrag/AntragsModel';
import { Bearbeitungsstand } from '../../../api/models/Status/Bearbeitungsstand';
import { CaseDetailsModel } from '../../../api/models/Case/CaseDetailsModel';
import useAssignment from '../../../shared/hooks/useAssignment';
import { SelectOption } from '../../../shared/utils/antragsuebersicht';
import { Property } from 'csstype';
import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes } from '../../../api/beh-api';

interface ZuweisungSachbearbeiterProps {
  readonly antragObj: AntragObj | CaseDetailsModel;
  readonly position?: Property.Position;
  readonly marginBottom?: string | undefined;
}

function ZuweisungTeamleiter(props: ZuweisungSachbearbeiterProps): JSX.Element {
  const assignedBearbeiterId = props.antragObj.bearbeiterDto?.id;
  const caseId = props.antragObj.caseId;

  const { assignCase, revokeCase, isPending } = useAssignment({
    antragObj: props.antragObj
  });

  const filteredOrgUnitName = `/${props.antragObj.organizationalUnitName}/Sachbearbeitung`;

  const caseAlreadyEdited =
    props.antragObj.firstInteractionTimestamp !== null &&
    props.antragObj.firstInteractionTimestamp !== undefined;

  const { data: users } = useQuery<Array<BearbeiterDto>>({
    queryKey: [BehApiRoutes.userFromOrgUnit(filteredOrgUnitName)]
  });

  const assignBearbeiterToCase = (newBearbeiterId: string) => {
    if (newBearbeiterId !== assignedBearbeiterId) {
      assignCase(newBearbeiterId, props.antragObj.version);
    }
  };

  const revokeBearbeiterFromCase = () => {
    if (props.antragObj.bearbeiterDto !== null) {
      revokeCase(props.antragObj.version);
    }
  };

  const updateBearbeiterAssignment = (newBearbeiterId: string) => {
    if (newBearbeiterId === 'null') {
      revokeBearbeiterFromCase();
    } else {
      assignBearbeiterToCase(newBearbeiterId);
    }
  };

  const toEmpty = (input: string | undefined) => {
    return input ? input : '';
  };

  function onChangeAssignment(value: string) {
    const newBearbeiterId = value;
    if (newBearbeiterId !== '') {
      updateBearbeiterAssignment(newBearbeiterId);
    }
  }

  if (props.antragObj.bearbeitungsstand === Bearbeitungsstand.ABGESCHLOSSEN) {
    return (
      <span id={`bearbeiter_${caseId}_${assignedBearbeiterId}`}>
        {props.antragObj.bearbeiterDto?.fullName ?? 'Keine Bearbeiter:in'}
      </span>
    );
  }

  if (isPending) {
    return <Skeleton height={40} width={200} />;
  } else if (users !== undefined) {
    const selectedItems: Array<SelectOption> = users?.map((b) => {
      return { label: b.fullName, value: b.id, disabled: false };
    });
    const notAssignedBearbeiter = {
      label: '- nicht zugewiesen -',
      value: 'null'
    };
    if (!caseAlreadyEdited) {
      selectedItems.unshift(notAssignedBearbeiter);
    }
    const assignedBearbeiter: SelectOption =
      props.antragObj.bearbeiterDto == null
        ? notAssignedBearbeiter
        : {
            label: toEmpty(props.antragObj.bearbeiterDto?.fullName),
            value: toEmpty(props.antragObj.bearbeiterDto?.id)
          };

    return (
      <div
        style={{
          width: '20rem'
        }}
      >
        <Select
          id={`zuweisung_select_${caseId}`}
          name={`zuweisung_select_name_${caseId}`}
          selectedOptions={[assignedBearbeiter]}
          onChange={(options) =>
            onChangeAssignment(options.at(0)?.value ?? 'null')
          }
          canDelete={false}
          options={selectedItems}
          aria-label={assignedBearbeiter.label}
        />
      </div>
    );
  } else {
    return <span id={'id'}>{props.antragObj.bearbeiterDto?.fullName}</span>;
  }
}
export default ZuweisungTeamleiter;
